import "jquery-match-height";

/*
 *
 * ----------------------------------------------- */
jQuery(window).on("load", function (e) {
  $(".text-sm").matchHeight({
    property: "min-height",
  });

  $(".well-corporate").matchHeight({
    property: "height",
    byRow: false,
  });
});
